export const Caret = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="Caret">
    <path id="icon" d="M8 20L24 20L16 10L8 20Z" fill="currentColor"/>
  </g>
</svg>`;
